import React from "react";
import Slider from "react-slick";
import { getMediaUrl } from "../../utils/media";

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

const slickSettings = {
  fade: true,
  autoplay: true,
  pauseOnHover: false,
  speed: 500,
  autoplaySpeed: 7000,
  accessibility: false,
  useCSS: true,
  swipe: true,
  swipeToSlide: true,
  arrows: false,
  dots: true,
  // customPaging: function(i) {
  //   return (
  //     <span></span>
  //   );
  // },
  responsive: [
    {
      breakpoint: 980,
      settings: {
        variableWidth: false,
        centerMode: false
      }
    }
  ]
};

const HomeHeroBanner = ({ homeBannerGroup }) => {
  return (
    <section className="content">
      <Slider className="slick-slider-full-banner-container" {...slickSettings}>
        {homeBannerGroup.length
          ? homeBannerGroup.map((banners, index) => (
              <div key={index}>
                {(() => {
                  const imageUrl = getMediaUrl(
                    banners.homeBanner.featuredImage
                  );
                  const mobileImageUrl = getMediaUrl(
                    banners.homeBanner.bannerDetails.bannerMobileImageUpload
                  );
                  const videoUrl = getMediaUrl(
                    banners.homeBanner.bannerDetails.videoBannerUpload
                  );
                  const mobileAlt =
                    `${banners.homeBanner.title} - HTB` ||
                    banners.homeBanner.bannerDetails.bannerMobileImageUpload
                      ?.altText ||
                    banners.homeBanner.featuredImage?.altText;
                  const mobileTitle =
                    `${banners.homeBanner.title} - HTB` ||
                    banners.homeBanner.bannerDetails.bannerMobileImageUpload
                      ?.title ||
                    banners.homeBanner.featuredImage?.title;
                  return (
                    <>
                      <div className="slick-content-container">
                        <div className="slick-inner-content-holder">
                          <div className="slick-title-holder slickStagger-0 slide-visible">
                            <h3
                              className="slickStagger-0"
                              dangerouslySetInnerHTML={{
                                __html: banners.homeBanner.title
                              }}
                            />
                          </div>

                          <div className="slick-text-holder slickStagger-0 slide-visible">
                            <div
                              className="slickStagger-0 hide-on-responsive"
                              dangerouslySetInnerHTML={{
                                __html: banners.homeBanner.content
                              }}
                            />
                          </div>
                          {banners.homeBanner.bannerDetails.bannerLinkText ? (
                            <div className="slick-link-holder slickStagger-2 slide-visible">
                              <a
                                href={
                                  banners.homeBanner.bannerDetails.bannerUrl
                                }
                              >
                                {
                                  banners.homeBanner.bannerDetails
                                    .bannerLinkText
                                }
                              </a>
                            </div>
                          ) : banners.homeBanner.bannerDetails.bannerUrl ? (
                            <div className="slick-link-holder slickStagger-2 slide-visible">
                              <a
                                href={
                                  banners.homeBanner.bannerDetails.bannerUrl
                                }
                              >
                                Read More
                              </a>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <>
                        {videoUrl ? (
                          <>
                            <div className="slick-full-video-holder hide-on-responsive">
                              <div className="video-wrapper">
                                <video
                                  width="100%"
                                  height="100%"
                                  autoPlay
                                  muted
                                  loop
                                  playsInline
                                >
                                  <source src={videoUrl} type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                              </div>
                            </div>

                            <div className="slick-full-image-holder show-on-responsive">
                              {mobileImageUrl || imageUrl ? (
                                <img
                                  src={mobileImageUrl || imageUrl}
                                  alt={mobileAlt}
                                  title={mobileTitle}
                                ></img>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className="slick-full-image-holder hide-on-responsive"
                              style={{
                                backgroundImage: imageUrl
                                  ? `url(${imageUrl}), linear-gradient(to right, #dfdfdf 0%, #dfdfdf 50%, #cdcdcd 51%, #cdcdcd 100%)`
                                  : undefined
                              }}
                            ></div>
                            <div className="slick-full-image-holder show-on-responsive">
                              {mobileImageUrl || imageUrl ? (
                                <img
                                  src={mobileImageUrl || imageUrl}
                                  alt={mobileAlt}
                                  title={mobileTitle}
                                ></img>
                              ) : null}
                            </div>
                          </>
                        )}
                      </>
                    </>
                  );
                })()}
              </div>
            ))
          : null}
      </Slider>
    </section>
  );
};

export default HomeHeroBanner;
